import { create } from "framer-motion/client";
import apiClient from "./base";

const api = {


    auth : {

        login : async ({email, password})=>{

            try{

                const { data } = await apiClient.post('/admin/login', {email, password})

                return data;

            }catch(e){
                throw e
            }

        },

        auto_login : async ()=>{
            
            try{

                const token = localStorage.getItem('token')
                // const { data } = await apiClient.post('/admin/auto_login', {}, {headers : {Authorization : `Bearer ${token}`}})
                const { data } = await apiClient.post('/admin/auto_login')

                return data;

            }catch(e){
                throw e
            }
        }
    },

    category : {

        create : async ({name, description})=>{


            try{

                const { data } = await apiClient.post("/category/create", {name, description})

                return data

            }catch(e){

                throw e
            }
        },

        read : async ()=>{


            try{

                const { data } = await apiClient.get("/category/read")

                return data

            }catch(e){

                throw e
            }
        },

        read_one : async ({id})=>{

            try{
                
                console.log(id)
                const { data } = await apiClient.get("/category/one", {params : { id : id}})

                console.log(data)
                return data

            }catch(e){

                throw e
            }
        },

        delete : async ({id})=>{

            try{

                const { data } = await apiClient.post("/category/delete", {}, {params : { id : id}})

                return data 

            }catch(e){

                throw e
            }
        },


        update : async (category)=>{


            try{

                const { data } = await apiClient.post("/category/update", category)

                return data

            }catch(e){

                throw e
            }
        },
    },

    product : {

        create : async (product)=>{

            try{
                const { data } = await apiClient.post("/product/create", product, {headers : {"Content-Type" : "multipart/form-data"}})

                return data

            }catch(e){

                throw e
            }

        },


        duplicate : async (product)=>{

            try {

                const { data } = await apiClient.post("/product/duplicate/particular", product)

                return data
                
            } catch (error) {
                throw error
            }
        },

        read_all : async ()=>{

            try {
                
                const { data } = await apiClient.get("/admin/product/get/all")

                return data 

            } catch (error) {
                throw error
            }

        },


        read_one : async ({id})=>{

            try {
                
                const { data } = await apiClient.get("/product/admin/get", {params : {id : id}})

                return data 

            } catch (error) {
                throw error
            }

        },

        delete : async ({id})=>{

            try{

                const { data } = await apiClient.post("/product/delete", {}, {params : { id : id}})

                return data 

            }catch(e){

                throw e
            }
        },


        update : async ({id, product})=>{

            try{
                const { data } = await apiClient.post("/product/update", product, {headers : {"Content-Type" : "multipart/form-data"}, params : {id : id}})

                return data

            }catch(e){

                throw e
            }

        },

        stock : {

            create : async (body)=>{

                try{

                    const { data } = await apiClient.post("/product/stock/create", body)

                    return data

                }catch(e){
                    console.log(e)
                    throw e
                }
            },


            readAll : async ({id})=>{

                try{

                    const { data } = await apiClient.get('/product/stock', {params : {id : id}})

                    return data

                }catch(e){

                    throw e
                }
            },

            
        }
    },

    admin : {

        add : async ({body})=>{

            try {

                const { data } = await apiClient.post("/admin/add", body)

                return data 
                
            } catch (error) {
                throw error
            }

        },

        add_location : async ({lon, lat})=>{

            try {
                
                await apiClient.post("/admin/location", {lon, lat})

                return;

            } catch (error) {
                throw error
            }
        },

        states : async ()=>{

            try {

                const { data } = await apiClient.get("/admin/state")

                return data 
                
            } catch (error) {
                
                throw error
            }
        },


        read_all : async ()=>{

            try{   

                const { data } = await apiClient.get("admin/")

                return data;

            }catch(e){

                throw e
            }
        },

        notification_subscribe : async ({subscribe, adminId})=>{

            try {
                
                await apiClient.post("/admin/notif/subscribe", {subscribe, adminId})
                return;

            } catch (error) {
                
                throw error
            }

        },

        read_one : async ({id})=>{

            try{   

                const { data } = await apiClient.get("admin/detail", {params : {id : id}})

                return data;

            }catch(e){

                throw e
            }
        },

        update : async ({body})=>{

            try {
                
                const { data } = await apiClient.post("/admin/update", body)

                return data
                
            } catch (error) {
                
                throw error
            }

        },

        delete : async ({id})=>{

            try{

                const { data } = await apiClient.post("/admin/delete", {}, {params : { id : id}})

                return data 

            }catch(e){

                throw e
            }
        },

        notif : {

            all : async (offset)=>{

                try {

                    const { data } = await apiClient.get("/admin/notif", {params : {offset : offset}})

                    return data
                    
                } catch (error) {
                    
                    throw error
                }
            },

            get_un_read : async ()=>{

                try {

                    const { data } = await apiClient.get("/admin/notif/un_read")

                    return data;
                    
                } catch (error) {
                    throw error
                }
            },


            mark_as_read : async (id)=>{

                try {
                    
                    const { data } = await apiClient.post("/admin/notif/asRead", { id : id})

                    return data;

                } catch (error) {
                    throw error
                }
            },


            mark_all_as_read : async ()=>{

                try {

                    const { data } = await apiClient.post("/admin/notif/allAsRead")
                    return data;

                } catch (error) {

                    throw error
                    
                }
            }
        },

        logs : async ()=>{

            try {
                
                const { data } = await apiClient.get("/admin/logs")

                return data

            } catch (error) {
                throw error
            }
        },

        backup : async ()=>{

            try {
                
                const { data } = await apiClient.get("/admin/backup")

                return data

            } catch (error) {
                throw error
            }
        },

        dowload_backup : async ({name})=>{

            try {
                
                const { data } = await apiClient.get("/admin/file/download", {params : {name : name}})

                return data

            } catch (error) {
                throw error
            }
        },

        create_backup : async ()=>{

            try {
                
                const { data } = await apiClient.post("/admin/backup/create")

                return data

            } catch (error) {
                throw error
            }
        },


        database_restor : async ()=>{

            try {
                
                const { data } = await apiClient.post("/admin/backup/restore")

                return data

            } catch (error) {
                throw error
            }
        }
    },

    promo : {
        create : async ({promo})=>{

            try {
                
                const { data } = await apiClient.post("/promo/create", promo);

                return data

            } catch (error) {
                throw error
            }
        },

        update : async ({promo})=>{

            try {
                
                const { data } = await apiClient.post("/promo/update", promo);

                return data

            } catch (error) {
                throw error
            }
        },

        read : {

            all : async ()=>{

                try {

                    const { data } = await apiClient.get("/promo")

                    return data
                    
                } catch (error) {
                    throw error
                }

            },

            one : async ({id})=>{

                try {
                    
                    const { data } = await apiClient.get("/promo/one", {params : {id : id}})

                    return data

                } catch (error) {
                    throw error
                }
            }
        },

        delete : async ({id})=>{

            try {
                
                const { data } = await apiClient.post("/promo/delete", {}, {params : {id : id}})

                return data

            } catch (error) {
                throw error
            }
        },

        product : {
            
            
            delete : async ({product_id, promotion_id})=>{

                try {

                    console.log(product_id, promotion_id)
                    const { data } = await apiClient.post("/promo/product/delete", {product_id, promotion_id})
                    
                    return data

                } catch (error) {
                    throw error
                }
            }
        }
    },

    user : {

        read : {

            all : async ()=>{

                try {

                    const { data } = await apiClient.get("/user/get")

                    return data 
                    
                } catch (error) {

                    throw error
                }
            },


            one : async ({id})=>{

                try {

                    const {data} = await apiClient.get("/user", {params : {id : id}})

                    return data 
                    
                } catch (error) {
                    
                    throw error
                }
            }
        }
    },


    order : {

        read : {
            
            all : async ()=>{

                try {

                    const { data } = await apiClient.get("/order")

                    return data 
                    
                } catch (error) {

                    throw error
                }
            },


            one : async ({id})=>{

                try {

                    const { data } = await apiClient.get("/order/details", {params : {id : id}})

                    return data 
                    
                } catch (error) {
                    
                    throw error
                }
            }
        },

        delete : async ({id})=>{

            try {

                const {data} = await apiClient.post("/order/delete", {}, {params : {id : id}})

                return data;
                
            } catch (error) {
                


            }

        },

        getGraphData : async (period)=>{

            try {

                const { data } = await apiClient.get('/order/graph', {params : {period : period}})

                return data
                
            } catch (error) {

                throw error
            }
        }
    },

    delivery : {

        read : {

            all : async ()=>{

                try {

                    const { data } = await apiClient.get("/admin/order/delivery")

                    return data 
                    
                } catch (error) {
                    throw error
                }
            },

            one : async ({id})=>{

                try {

                    const { data } = await apiClient.get("/order/delivery/one", {params : {id : id}})

                    return data 
                    
                } catch (error) {
                    
                    throw error
                }
            }
        },

        update : async (delevery)=>{

            try {

                const { data } = await apiClient.post("/order/delivery/update", delevery)

                return data 
                
            } catch (error) {
                throw error
            }
        },

        create_delivery_price : async (data)=>{

            try {
                
                await apiClient.post("/admin/delivery_price/create", data)

                return; 

            } catch (error) {
                
                throw error
            }
        },


        delete_delivery_price : async (id)=>{

            try {
                
                await apiClient.post("/admin/delivery_price/delete", {id : id})

                return; 

            } catch (error) {
                
                throw error
            }
        },


        get_delivery_price : async ()=>{

            try {
                
                const { data } = await apiClient.get("/admin/delivery_price")
                
                return data

            } catch (error) {
                
                throw error
            }
        },

        updatePayment : {

            status : async ({id, status})=>{
                
                try {
                    
                    const { data } = await apiClient.post("/admin/order/delivery/status/update", {id : id, status : status})

                    return data

                } catch (error) {
                    
                    throw error
                }
            }
        }
    
    },

    apiKey : {

        create : async (key)=>{

            try {
                
                const {data} = await apiClient.post("/admin/apikey/create", key);

                return data;

            } catch (error) {

                throw error
            }
        },

        delete : async (id)=>{

            try {
                
                await apiClient.post("/admin/apikey/delete", {id : id});

                return;

            } catch (error) {

                throw error
            }
        },


        get : async ()=>{

            try {
                
                const { data } = await apiClient.get("/admin/apikey");

                return data;

            } catch (error) {

                throw error
            }
        }

    }

    
}


export default api;